import { render, staticRenderFns } from "./LinkColumnWithImage.vue?vue&type=template&id=17ead922&scoped=true&"
import script from "./LinkColumnWithImage.vue?vue&type=script&lang=ts&"
export * from "./LinkColumnWithImage.vue?vue&type=script&lang=ts&"
import style0 from "./LinkColumnWithImage.vue?vue&type=style&index=0&id=17ead922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ead922",
  null
  
)

export default component.exports